module.exports = __webpack_public_path__ + "zvetseni-rtu-permalip_2_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/zvetseni-rtu-permalip_2_before_tn.jpg
// module id = 1844
// module chunks = 0